import React from 'react';
import { faCalendarCirclePlus } from '@fortawesome/pro-light-svg-icons';
import styled from 'styled-components';
import { rem } from 'polished';
import { Text } from '../Text';
import { Button } from '../Button';
import { Rectangle } from '../Rectangle';

const StyledBanner = styled.div`
  width: 100%;
  margin-bottom: ${rem(`48px`)};
  ${({ theme }) => theme.breakpoints.desktop`
      padding-top: ${rem(`60px`)};
      margin-bottom: ${rem(`136px`)};
    `}
  .rectangle {
    padding: ${rem(`16px`)};
    flex-wrap: wrap;
    ${({ theme }) => theme.breakpoints.tablet`
        padding: ${rem(`36px`)};
      `}
    ${({ theme }) => theme.breakpoints.desktop`
        padding: ${rem(`85px`)};
      `}
  }
  .banner__title {
    width: 100%;
    flex: 1 0 auto;
    text-align: center;
    font-size: ${rem(`28px`)};
    line-height: ${rem(`36px`)};
    ${({ theme }) => theme.breakpoints.phablet`
      line-height: ${rem(`48px`)};
    `}
    ${({ theme }) => theme.breakpoints.desktop`
      font-size: ${rem(`32px`)};
    `}
  }
  .banner__content {
    width: 100%;
    flex: 1 0 auto;
    text-align: center;
    font-weight: 400;
    font-size: ${rem(`20px`)};
    line-height: ${rem(`24px`)};
    margin-bottom: ${rem(`24px`)};
    ${({ theme }) => theme.breakpoints.desktop`
      font-size: ${rem(`24px`)};
      line-height: ${rem(`36px`)};
    `}
  }

  .banner__cta {
    flex: 1 0 auto;
    display: flex;
    justify-content: center;
  }
`;

interface IBanner {
  className?: string;
  title: string;
  content: string;
  cta: string;
}

export const Banner = ({ title, content, className, cta }: IBanner) => {
  const onClickHandler = () => {
    // eslint-disable-next-line no-undef
    Calendly.initPopupWidget({
      url: `https://calendly.com/domusnetwork?hide_landing_page_details=1&hide_gdpr_banner=1`,
      parentElement: document.getElementById(`calendly-embed`),
      resize: true,
    });
    return false;
  };

  return (
    <StyledBanner className={`banner ${className}`}>
      <Rectangle className="rectangle">
        <Text
          className="banner__title"
          type="title3"
          tag="div"
          color="yellow_1"
          noRhythem
        >
          {title}
        </Text>
        <Text
          className="banner__content"
          type="title4"
          tag="div"
          color="gray_3"
          noRhythem
        >
          {content}
        </Text>
        <div className="banner__cta">
          <Button
            size="large"
            iconLeft={faCalendarCirclePlus}
            onClick={onClickHandler}
          >
            {cta}
          </Button>
        </div>
      </Rectangle>
    </StyledBanner>
  );
};
